<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div :class="[(websiteMsg&&['WEB-003','WEB-004'].includes(websiteMsg.webTemplate)) && 'web-module-003-container']">
    <template v-if="websiteMsg">
      <div
        v-if="websiteMsg.webTemplate==='WEB-001' || (['WEB-003','WEB-004'].includes(websiteMsg.webTemplate) && $route.query.type)"
        class=""
      >
        <el-scrollbar
          ref="scrollMenuRef"
          style="height:100vh"
        >
          <div class="data_body">
            <div
              v-if="dataList.contentType == 0"
              class="ifmContent"
              v-html="dataList.contentText"
            />
            <div
              v-if="dataList.contentType == 1"
              class="ifmebox"
            >
              <iframe
                :src="dataList.contentLink"
                frameborder="0"
                class="ifme"
              />
            </div>
            <!-- 列表进入 视频 -->
            <div
              v-if="dataList.contentType == 2"
              class="videocontent"
            >
              <video
                ref="myVideo"
                :src="dataList.contentVideo"
                autoplay="autoplay"
                controls="controls"
              />
            </div>
            <div
              v-if="JSON.stringify(dataList)=='{}'"
              class="nodata"
            >
              <img
                class="nodata_img"
                style="height:195px"
                src="../../../assets/image/icon_data_delete.png"
                alt=""
              >
              <span class="nodata_text2">暂无内容哦~</span>
            </div>
          </div>
        </el-scrollbar>
      </div>

      <div
        v-else-if="websiteMsg.webTemplate==='WEB-002' || (['WEB-003','WEB-004'].includes(websiteMsg.webTemplate) && $route.query.type)"
        class="web2"
      >
        <div
          v-if="!Preview"
          class="pageHeader"
        >
          <div
            class="pageHeader_left"
          >
            <img
              v-if="websiteMsg.logo"
              :src="websiteMsg.logo"
              alt=""
            >
            <span>{{ websiteMsg.name }}</span>
          </div>
          <div class="searchDiv">
            <el-autocomplete
              v-model="seachValue"
              suffix-icon="el-icon-search"
              class="inline-input"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容标题或内容关键字进行搜索"
              :trigger-on-focus="false"
              @select="handleSelect"
            >
              <template slot-scope="{item}">
                <div class="item_bottom">
                  <p
                    v-show="item.title"
                    class="highLight-title"
                    v-html="highLightTableMsg(item.title,seachValue)"
                  />
                  <span
                    v-show="item.keyWord"
                    class="highLight-keyWord"
                    v-html="highLightTableMsg(item.keyWord,seachValue)"
                  />
                </div>
              </template>
            </el-autocomplete>
          </div>
        </div>
        <div
          class="body_data"
          :class="queryCatalogId?'maxHeight':''"
        >
          <div
            :class="Preview?'body_data_left2':'body_data_left'"
          >
            <el-scrollbar
              v-if="!Preview"
              class="scrollHeight2"
            >
              <el-tree
                ref="treeList"
                class="column-tree "
                :data="treeData"
                :props="defaultProps"
                node-key="contentId"
                :highlight-current="true"
                :default-expand-all="true"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
              >
                <div
                  slot-scope="{ node, data }"
                  class="custom-tree-node"
                  :title="data.name"
                >
                  <div :class="[data.isContent ? 'content-box' : 'catalogue-box']">
                    <span
                      :class="{'img': data.isContent, 'circle': data.children && !data.children.length}"
                    />
                    <span
                      :id="data.contentId"
                      class="treeItem"
                    >
                      {{ data.name }}
                    </span>
                  </div>
                </div>
              </el-tree>
            </el-scrollbar>
          </div>
          <el-scrollbar
            ref="scrollMenuRef"
            class="scrollHeight "
            :class="[queryCatalogId?'maxHeight':'',treeData.length?'scrollRight':'']"
          >
            <div
              class=""
              :class="[queryCatalogId?'maxHeight':'',treeData.length?'body_data_right':'body_data_right2']"
            >
              <div
                :class="treeData.length?'center':'data_body'"
              >
                <div>
                  <div
                    v-if="dataList.contentType == 0"
                    ref="refContent"
                    class="ifmContent"
                    @click="imageEnlargement"
                    v-html="dataList.contentText"
                  />
                  <div
                    v-if="dataList.contentType == 1"
                    class="ifmebox"
                  >
                    <iframe
                      :src="dataList.contentLink"
                      frameborder="0"
                      class="ifme"
                    />
                  </div>
                  <!-- 列表进入 视频 -->
                  <div
                    v-if="dataList.contentType == 2"
                    class="videocontent"
                  >
                    <video
                      ref="myVideo"
                      :src="dataList.contentVideo"
                      autoplay="autoplay"
                      controls="controls"
                    />
                  </div>
                </div>

                <div
                  v-if="JSON.stringify(dataList)=='{}'"
                  class="nodata"
                >
                  <img
                    class="nodata_img"
                    style="height:195px"
                    src="../../../assets/image/icon_data_delete.png"
                    alt=""
                  >
                  <span class="nodata_text2">暂无内容哦~</span>
                </div>
              </div>
            </div>
            <!-- 友情链接模块 -->
            <div
              v-if="partenrlist.length "
              class="foot"
            >
              <div
                v-for="(item,index) in partenrlist"
                :key="index"
                class="link_item"
                @click="openLink(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <web003 v-else-if="websiteMsg.webTemplate==='WEB-003' && !$route.query.type" />
      <web004 v-else-if="websiteMsg.webTemplate==='WEB-004' && !$route.query.type" />
    </template>
    <div
      v-if="showBox"
      class="theVideoStratum"
    >
      <div
        style="width: 100%; height: 100%; background-color: rgba(0, 0, 0)"
        class="closeTheVideo"
        @click="showBox = false"
      />
      <div class="theVideoStratumBox">
        <video
          ref="myVideo"
          :src="videoUrl"
          autoplay="autoplay"
          controls="controls"
        />
      </div>
    </div>
    <div
      v-show="showTop"
      class="backTopDiv"
      @click="backTop"
    >
      <i class="el-icon-caret-top" />
    </div>
    <!-- 图片弹窗 -->
    <template v-if="websiteMsg && (!['WEB-003','WEB-004'].includes(websiteMsg.webTemplate) || !$route.query.type)">
      <el-dialog
        :visible.sync="showImgDialog"
        width="50%"
      >
        <div
          slot="title"
          class="dialog-title"
        >
          <span>{{ dialogtitle }}</span>
        </div>
        <div
          class="dialogimgdiv"
        >
          <img
            :src="dialogimg"
            alt=""
          >
        </div>
      </el-dialog>
      <viewer
        ref="viewer"
        :images="photo"
        :index="1"
        @inited="inited"
      >
        <img
          v-for="(src,index) in photo"
          :key="index"
          style="display: none;"
          :src="src"
        >
      </viewer>
    </template>
  </div>
</template>

<script>
import api from './proxy';
import { removeWatermark, setWaterMark } from '../../../lib/watermark';
import web003 from './web003';
import web004 from './web004';
export default {
    components: { web003, web004 },
    data () {
        return {
            catalogId: '',
            dataList: {},
            websiteMsg: {},
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            treeData: [],
            // highlight: false,
            isList: true,
            seachValue: '',
            partenrlist: [],
            showBox: false,
            showTop: false,
            videoUrl: '',
            Preview: false,
            code: '',
            siteId: '',
            queryCatalogId: '',
            dialogtitle: '图片预览', // 弹窗名称
            showImgDialog: false,
            dialogimg: '',
            photo: [],
        };
    },
    mounted () {
        this.code = this.$route.query.code;
        this.queryCatalogId = this.$route.query.contentId;
        this.siteId = this.$route.query.siteId || '';
        console.log('this.siteId', this.siteId);
        if (this.siteId === 'undefined') this.siteId = '';
        console.log('queryCatalogId', this.queryCatalogId);
        this.Preview = false;
        // if (!this.IsPC()) {
        //     this.$router.replace({ name: 'mobileContent', query: this.$route.query });
        // }
        if (this.code) {
            this.getSite();
        } else if (this.queryCatalogId) {
            this.getWebSiteMsg3();
        } else if (this.siteId) {
            sessionStorage.setItem('urlSiteId', this.siteId);
            this.getWebSiteMsg();
        } else {
            this.getWebSiteMsg2();
        }
    },
    methods: {
        getSite () {
            let params = {
                code: this.code,
            };
            api.getSiteByCode(params).then(res => {
                if (res.errcode === 0) {
                    this.siteId = res.data.id.toString();
                    console.log(111, this.siteId);
                    sessionStorage.setItem('urlSiteId', this.siteId);
                    this.getWebSiteMsg();
                }
            });
        },
        scrollMenu () {
            let showTop = this.$refs.scrollMenuRef.wrap.scrollTop;
            showTop > 400 ? this.showTop = true : this.showTop = false;
        },
        inited (viewer) {
            this.$viewer = viewer;
            this.$viewer.index = this.activeIndex;
            // 不要他的按钮
            this.$viewer.options.button = false;
            // 不要他的底部缩略图
            this.$viewer.options.navbar = false;
            // 不要他的底部标题
            this.$viewer.options.title = false;
            // 不要他的底部工具栏
            this.$viewer.options.toolbar = false;
        },
        // 调用显示
        show () {
            this.$viewer.show();
        },
        imageEnlargement (e) {
            if (e.target.nodeName == 'IMG') { // 判断点击富文本内容为img图片
                this.photo = [];
                this.photo.push(e.target.currentSrc);
                this.show();
            } else {
                console.log('点击内容不为img');
            }
        },
        // 获取栏目列表 通过栏目内容id获取所有内容
        getDataList (type) {
            const params = {
                siteId: Number(sessionStorage.getItem('urlSiteId')) || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: this.catalogId || null,
                keyWord: '',
                pageNo: 1,
                pageSize: 999,
            };
            api.getPageList(params).then((res) => {
                if (res.errcode === 0) {
                    let dataList = res.data.list;
                    if (dataList.length) {
                        dataList.sort((a, b) => {
                            return a.rank > b.rank;
                        });
                        this.catalogDetail(dataList[0].contentId);
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        getContentData (data) {
            const params = {
                siteId: Number(sessionStorage.getItem('urlSiteId')) || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: data.catalogId || null,
                keyWord: '',
                pageNo: 1,
                pageSize: 999,
            };
            api.getPageList(params).then((res) => {
                if (res.errcode === 0) {
                    let dataList = res.data.list;
                    console.log('nr', dataList);
                    if (dataList.length && dataList[0].status === 1) {
                        this.catalogDetail(dataList[0].contentId);
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 获取内容
        catalogDetail (id) {
            let { contentId, type } = this.$route.query;
            if (contentId && id) {
                let newUrl = window.location.origin + `/yxp-page-manage/#/webModulePage?contentId=${id}`;
                if (this.siteId) {
                    newUrl += '&siteId=' + this.siteId;
                }
                if (type) {
                    newUrl += '&type=' + type;
                }
                window.history.replaceState('', '', newUrl);
            }
            let params;
            if (this.$route.query.type) {
                params = {
                    siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
                    contentId: id,
                    type: 1,
                };
            } else {
                params = {
                    siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
                    contentId: id,
                };
            }
            api.getInfoCintent(params).then(res => {
                console.log(2222, res);
                if (res.errcode === 0) {
                    let dataList = res.data;
                    if (this.$route.query && this.siteId || this.code) {
                        dataList.publishStatus === 1 ? this.dataList = dataList : this.dataList = {};
                    } else {
                        this.dataList = res.data;
                        // console.log(this.dataList);
                    }
                    if (this.websiteMsg.webTemplate) {
                        this.$nextTick(() => {
                            this.$refs.scrollMenuRef && this.$refs.scrollMenuRef.wrap.addEventListener('scroll', this.scrollMenu);
                        });
                    }
                }
            });
        },
        IsPC () {
            var userAgentInfo = navigator.userAgent;
            var Agents = ['Android', 'iPhone',
                'SymbianOS', 'Windows Phone',
                'iPad', 'iPod'];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        // 视频弹窗
        showVideo (item) {
            console.log(item);
            this.videoUrl = item.contentVideo;
            this.showBox = true;
        },
        // 获取站点模板信息
        getWebSiteMsg () {
            let params = {
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.websiteInfo(params).then(res => {
                if (res.errcode === 0) {
                    this.websiteMsg = res.data.value;
                    if (['WEB-003', 'WEB-004'].includes(this.websiteMsg.webTemplate) && !this.$route.query.type) {
                        if (this.$route.query.preview) {
                            Object.assign(this.websiteMsg, { isPreview: true });
                        }
                        sessionStorage.setItem('websiteMsg', JSON.stringify(this.websiteMsg));
                        return;
                    };
                    if (this.websiteMsg.webTemplate === 'WEB-002') {
                        // 获取站点信息后获取树列表
                        this.getTreeList();
                        // 获取站点信息后获取友情链接列表
                        this.getPartnerList();
                    } else {
                        this.getDataList();
                    }
                    // sessionStorage.setItem('websiteMsg', JSON.stringify(this.websiteMsg));
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 获取站点模板信息
        getWebSiteMsg2 () {
            let params = {
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.websiteInfo(params).then(res => {
                if (res.errcode === 0) {
                    this.websiteMsg = res.data.value;
                    if (['WEB-003', 'WEB-004'].includes(this.websiteMsg.webTemplate) && !this.$route.query.type) {
                        if (this.$route.query.preview) {
                            Object.assign(this.websiteMsg, { isPreview: true });
                        }
                        sessionStorage.setItem('websiteMsg', JSON.stringify(this.websiteMsg));
                        return;
                    };
                    setTimeout(() => {
                        setWaterMark(this.websiteMsg.name, '预览');
                    }, 0);
                    if (this.websiteMsg.webTemplate === 'WEB-002') {
                        // 获取站点信息后获取树列表
                        this.getTreeList();
                        // 获取站点信息后获取友情链接列表
                        this.getPartnerList();
                    } else {
                        this.getDataList();
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        backTop () {
            this.$refs.scrollMenuRef.wrap.scrollTop = 0;
        },
        // 预览及复制链接进入 获取站点模板信息
        getWebSiteMsg3 () {
            if (this.siteId) {
                sessionStorage.setItem('urlSiteId', this.siteId);
            }
            let params = {
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.websiteInfo(params).then(res => {
                if (res.errcode === 0) {
                    this.websiteMsg = res.data.value;
                    if (['WEB-003', 'WEB-004'].includes(this.websiteMsg.webTemplate) && !this.$route.query.type) {
                        if (this.$route.query.preview) {
                            Object.assign(this.websiteMsg, { isPreview: true });
                        }
                        sessionStorage.setItem('websiteMsg', JSON.stringify(this.websiteMsg));
                        return;
                    };
                    // 判断是否带有站点id 有为复制链接进入  内容为正式的
                    if (!this.siteId) {
                        setTimeout(() => {
                            setWaterMark(this.websiteMsg.name, '预览');
                            this.Preview = true;
                        }, 0);
                    }
                    console.log(this.websiteMsg.webTemplate);
                    if (this.websiteMsg.webTemplate === 'WEB-002') {
                        this.catalogDetail(this.queryCatalogId);
                        // if (!this.queryCatalogId) {
                        this.getTreeList();
                        // }
                    } else {
                        this.catalogDetail(this.queryCatalogId);
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        // 获取友情链接列表
        getPartnerList () {
            let params = {
                webSiteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
            };
            api.getPartnerList(params).then((res) => {
                if (res.errcode === 0) {
                    this.partenrlist = res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        getimgsrc: function (e) {
            if (e.target.tagName.toUpperCase() === 'IMG') {
                this.showImgDialog = true;
                this.dialogimg = e.target.src;
                console.log(e.target.src);
            }
        },
        // 获取树状列表
        getTreeList () {
            let parmas = {
                isShowDisable: 0,
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
                catalogId: '',
                showContent: 1,
                useScene: this.$route.query.code || this.siteId ? 1 : 0,
            };
            api.getTreeList(parmas).then(res => {
                // this.treeData
                let treeData = res.data.value.catalogList;
                this.treeData = this.setTreeNode(treeData);

                if (!this.queryCatalogId && this.websiteMsg && this.websiteMsg.webTemplate === 'WEB-002') {
                    if (this.treeData[0].contentId) {
                        this.catalogDetail(this.treeData[0].contentId);
                        this.$nextTick(() => {
                            this.$refs.treeList.setCurrentKey(this.treeData.contentId);
                        });
                    } else {
                        new Promise((resolve, reject) => {
                            this.setHightNode(this.treeData[0].children, resolve);
                        }).then(res => {
                            this.catalogDetail(res);
                        });
                    }
                } else {
                    if (this.queryCatalogId) {
                        this.$nextTick(() => {
                            this.$refs.treeList.setCurrentKey(this.queryCatalogId);
                        });
                    }
                }
                if (this.websiteMsg && !this.queryCatalogId && this.websiteMsg.webTemplate === 'WEB-002') {
                    this.$nextTick(() => {
                        this.$refs.treeList.setCurrentKey(this.queryCatalogId);
                    });
                }
                this.$nextTick(() => {
                    const node = document.getElementById(this.queryCatalogId);
                    if (node) {
                        // this.$nextTick(() => {
                        node.scrollIntoView({ block: 'center' }); // 通过scrollIntoView方法将对应的dom元素定位到可见区域 【block: 'center'】这个属性是在垂直方向居中显示
                        // });
                    }
                });
            });
        },
        setHightNode (data, resolve) {
            if (data.contentId || data[0].contentId) {
                this.$nextTick(() => {
                    this.$refs.treeList.setCurrentKey(data.contentId || data[0].contentId);
                });
                resolve(data[0].contentId);
            } else {
                this.setHightNode(data.children || data[0].children, resolve);
            }
        },
        setTreeNode (data) {
            data.forEach(item => {
                if (item.contents.length) {
                    console.log(item.contents);
                    item.contents.forEach(contentItem => {
                        contentItem.name = contentItem.title;
                    });
                }
                if (item.children.length) {
                    this.setTreeNode(item.children);
                }
                if (this.Preview || this.siteId || this.queryCatalogId) {
                    item.children = [...item.contents, ...item.children];
                } else {
                    let newarr = [];
                    item.contents.forEach(contentItem => {
                        if (contentItem.publishStatus === 1) {
                            newarr.push(Object.assign(contentItem, { isContent: true }));
                        }
                    });
                    item.children = [...newarr, ...item.children];
                }
            });
            return data;
        },
        // 友情链接事件
        openLink (data) {
            location.href = data.link;
        },
        handleNodeSetHight (node) {
            console.log(node);
            if (node.children[0].contentId) {
                this.$nextTick(() => {
                    this.$refs.treeList.setCurrentKey(node.children[0].contentId);
                });
                // return data[0].contentId;
            } else {
                this.handleNodeSetHight(node.children[0]);
            }
        },
        // 左侧树点击事件
        handleNodeClick (node, data) {
            console.log(11111, node);
            // 判断点击的是栏目还是内容
            let id = this.$route.query.contentId;
            if (id && node.contentId) {
                const newUrl = window.location.origin + `/yxp-page-manage/#/webModulePage?contentId=${node.contentId}&siteId=${this.siteId}`;
                window.history.replaceState('', '', newUrl);
            }
            if (node.siteId) {
                // this.highlight = true;
                this.catalogId = node.catalogId;
                this.dataList = {};
                this.getContentData(node);
                this.handleNodeSetHight(node);
            } else {
                this.dataList = {};
                // 判断是否为预览
                if (this.Preview || this.siteId) {
                    this.catalogDetail(node.contentId);
                } else {
                    // 判断当前内容状态
                    if (node.publishStatus === 1) {
                        this.catalogDetail(node.contentId);
                    }
                }
            }
        },
        querySearch (queryString, cb) {
            let parmas = {
                siteId: sessionStorage.getItem('urlSiteId') || this.$store.getters['system/getSiteList'][0].siteId,
                keyWord: queryString,
                useScene: this.code ? 1 : 0,
            };
            api.getSearchInfo(parmas).then((res) => {
                if (res.errcode === 0) {
                    cb(res.data);
                }
            });
        },
        handleSelect (item) {
            console.log(item);
            this.dataList = [];
            this.catalogDetail(item.contentId);
            this.$nextTick(() => {
                this.$refs.treeList.setCurrentKey(item.contentId);
            });
        },
        destroyed () {
            removeWatermark();
        },
    },
};

</script>
<style>
.ifmContent  p  img{
  /* display: block;
  margin: 0 auto; */
}
.ifmContent  p  video{
  /* position: relative;
  left: 35%; */
    width: 300px;
    margin: 0 auto !important;
    display: block;
}
data[type="video"] {
  display: block !important;
}

</style>
<style lang='scss' scoped>
::v-deep .el-scrollbar {
    .el-scrollbar__wrap {
        scroll-behavior: smooth;
    }
}
.web-module-003-container {
    width: 100%;
    height: 100%;
}
.data_body{
  max-width: 1024px;
  margin: 0 auto;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.data_body2{
  margin-left: 20%;
  // position: relative;
  // margin: 0 auto;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.ifmContent{
  width: 100%;
  // height: 605px;
  overflow-x: hidden;
  overflow-y: scroll;
  // text-align: center;
  // border: 1px solid #e9eaec;
  // padding: 5px;
  a{
      text-decoration:underline;
      color:#428bca;
  }
}
.dialogimgdiv{
  width: 100%;
  height: 100%;
  img{
    width: 100%;
    height: 100%;
  }
}
.scrollRight{
  width: calc(100vw - 300px);
}
.scrollHeight{
  height: calc(100vh - 61px);
}
.scrollHeight2{
  height: calc(100vh - 62px);
}
.backTopDiv{
  cursor: pointer;
  position: fixed;
  bottom: 100px;
  right: 100px;
  width: 40px;
  height: 40px;
  z-index: 2000;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  color: #2ed095;
  -webkit-box-shadow: 0 0 4px 1px #909399;
  box-shadow: 0 0 4px 1px #929497;
  border-radius: 50%;
  background: #fff;
}
.ifmebox {
    width: 100%;
    height: 580px;
    // max-height: 100vh;
  }
 .ifme {
    width: 100%;
    height: 100%;
  }
.ifmContent::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 0px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
  }
  .pageHeader{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    border-bottom: 1px solid #EBEAEA;
    .pageHeader_left{
      display: flex;
      align-items: center;
      img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
  .body_data{
    height: calc(100vh - 61px);
    display: flex;
    width: 100%;
    .body_data_left{
      width: 300px;
      height: 100%;
      background: #F9F9FA;
    }
    .body_data_left2{
      width: 300px;
      height: 100%;
      background: none;
    }
    .body_data_right{
      width: calc(100vw - 300px);
      min-height: calc(100vh - 111px);
      // padding: 20px 34px;
      // overflow: auto;
      // overflow-x: hidden;
      // overflow-y: scroll;
    }
    .body_data_right2{
      width: 100vw;
      min-height: calc(100vh - 111px);
    }
  }
.body_data /deep/ .el-scrollbar__wrap{
  overflow: auto;
}
//没有子节点
.body_data_left /deep/ .el-tree .el-tree-node__expand-icon.is-leaf::before {
//   content: "•";
  content: "";
  font-size: 25px;
  width: 12px;
  height: 12px;
  display: block;
  position: relative;
  top: -2.3px;
}
.body_data_left /deep/ .column-tree {
  &.el-tree{
    background: none;
  }
  .is-leaf {
    color: #C0C4CC;
  }
  .content-box {
    display: flex;
    .img {
        position: relative;
        left: -6px;
        flex-shrink: 0;
        // display: inline-block;
        width: 18px;
        height: 18px;
        background-image: url('../../../assets/icon/icon_ml.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
  }
  .catalogue-box {
      display: flex;
      align-items: center;
      .circle {
        position: relative;
        left: -3px;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ddd;
        margin-right: 3px;
      }
  }
  .is-current .el-tree-node__content .is-leaf{
    padding: 0 6px;
  }
  .el-tree-node {
    .el-tree-node__expand-icon {
      margin-left: 5px !important;
    }
  }
  .el-tree-node__content {
    // padding-left: 20px !important;
    height: 40px;
    padding-right: 17px;
    &.el-tree-node__label {
      color: #70d29e;
    }
  }
  .custom-tree-node {
    width: 100%;
    // padding-left: 29px;
    margin-left: -29px;
    height: 100%;
    padding: 10.5px 0 10.5px 29px;
  }
  .treeItem {
    width: 100%;
  }
  .el-tree-node__expand-icon,
  .el-tree-node__label {
    padding: 6px;
  }
  &.el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #F9F9FA;
    color: #70d29e;
    .el-tree-node__expand-icon {
      color: #70d29e;
    }
    .el-tree-node__label {
      border-color: #70d29e;
    }
    .content-box {
        .img {
            background-image: url('../../../assets/icon/icon_ml_active.png');
        }
    }
    .catalogue-box {
      .circle {
        background: #70d29e;
      }
  }
  }
}
.foot{
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #EBEAEA;
  padding: 10px 0;
  background: #8E8E8E;
  // position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  .link_item{
    margin-right: 20px;
    cursor: pointer;
    color: #FFFFFF;
  }
  .link_item:hover{
    color: #2FD095;
  }
  // position: relative;
  // top: -20px;
}
.nodata{
  padding-top: 25vh;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.item_bottom{
  border-bottom: 1px solid #EBEAEA;
  .contentRow{
      max-height: 65px;
      width: 260px;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 这里是超出几行省略 */
      overflow: hidden;
  }
  .contentRow /deep/ p{
      width: 260px;
      white-space: pre-wrap;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 这里是超出几行省略 */
      overflow: hidden;

}
}

.theVideoStratum {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.theVideoStratumBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  // width: 100% !important;
  video{
    width: 100%;
  }
}
.play_icon {
  width: 50px;
  height: 50px;
  position: relative;
  top: -150px;
  left: 45%;
}
.videocontent{

//  margin:  0 auto ;
 position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
//  width: 500px;
//  height: 240px;
 video{
   width: 100%;
   height: 100%;
 }
}
.center{
  margin: 0 auto;
  width: 1024px;
  // margin-bottom: 10px;
}
.inline-input{
  width: 300px;
}
.highLight-title{
  font-size: 16px;
  max-height: 65px;
  width: 260px;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.highLight-keyWord{
  padding: 5px 14px;
  background: #F2F2F4;
  color: #333333;
  border-radius: 4px;
}
.treeItem{
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space:nowrap;
  width:200px;
}
.maxHeight{
  height: 100vh;
}
</style>

<style>
 .log-hight-light {
  color: #3CD39D;
}
</style>
